import { TFunction } from "i18next";
import * as Yup from "yup";

export const createReviewFormValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        employeeId: Yup.number().required(t("validation.required")),
        name: Yup.string().required(t("validation.required")),
        rating: Yup.number().required(t("validation.required")),
    });
